import React from 'react';
import { connect } from 'react-redux';
import properties from '../../../modules/ajio-util/properties';
import * as actions from '../../../actions/productData';
import { fetchSizeAndBrandSize, beautyCheck } from '../../../utils/StandardSizeUtils.js';
import { getNewSizeRevampFlag } from '../../../Flags/selectors.js';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import { getStoresForHidingMRP } from '../../../refresh/selectors/featureFlagsSelector';
import { replaceWithJioCDN } from '../../../../src/utils/imageHandling';

class CartPopup extends React.Component {
  render() {
    let {
      minicart = {},
      newSizeRevampFlag,
      newDesignLuxe,
      storesForHidingMRP,
      isStreetStore
    } = this.props;
    let entries = minicart.entries || [];
    let { subTotal = {} } = minicart;
    let { formattedValue = '' } = subTotal;
    let { length = 0 } = entries;
    let { metaData: { sis = false } = {} } = this.props;

    if (!entries.length) {
      return (
        <div className="small-popup ">
          <div className="ic-toparw" />
          <div className="popup-inner minicart">
            <div className="minicart-block">
              <div className="minicart-empty-header" aria-label="Your Bag Is Empty Start Filling It Up!">
                Your Bag Is Empty <br /> Start Filling It Up!
              </div>
            </div>
            <div className="cart-smsg" aria-label="Free Shipping & Returns | 100% Handpicked | Assured Quality">
              Free Shipping & Returns | 100% Handpicked | Assured Quality
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="small-popup">
        <div className="ic-toparw" />
        <div className="popup-inner minicart">
          <div className="minicart-block">
            <div className="minicart-header" aria-label={newDesignLuxe ? "Items added to your cart" : "Item(s) added to your bag" }>
              {' '}
              {newDesignLuxe ? 'Items added to your cart' : 'Item(s) added to your bag'}
            </div>
            <div className={`minicart-products ${length > 2 ? 'noScroll' : ''}`}>
              <DataList
                storesForHidingMRP={storesForHidingMRP}
                data={entries}
                removeCartProduct={this.props.removeCartProduct}
                newSizeRevampFlag={newSizeRevampFlag}
              />
            </div>

            <div className="minicart-totalamt" aria-label={newDesignLuxe ? 'Total: ': 'Total '}>
              {newDesignLuxe ? 'Total: ' : 'Total '} <span><strong>{formattedValue}</strong></span>
            </div>

            <a
              href={
                sis && !newDesignLuxe && !isStreetStore
                  ? `${properties.getProperty('parentUrl')}/cart`
                  : '/cart'
              }
              className="cart-block-bag"
            >
              <div className="minicart-btn-blk">
                <div className="mini-cart-btn" aria-label={`PROCEED TO ${newDesignLuxe ? 'CART' : 'BAG'}`}>PROCEED TO {newDesignLuxe ? 'CART' : 'BAG'}</div>
              </div>
            </a>
          </div>
          <div className="cart-smsg" aria-label="Free Shipping & Returns | 100% Handpicked | Assured Quality">
            Free Shipping & Returns | 100% Handpicked | Assured Quality
          </div>
        </div>
      </div>
    );
  }
}

class DataList extends React.Component {
  removeCartProduct(entry, sizeCode, quantity) {
    this.props.removeCartProduct(entry, sizeCode, quantity);
  }

  render() {
    let { data = [], newSizeRevampFlag, newDesignLuxe, storesForHidingMRP } = this.props;
    var dataListItems = data.map((data, index) => {
      let image;
      let altText;
      let { product = {}, entryNumber, quantity, basePrice = {} } = data;
      let { wasPriceData = {}, images = [], baseOptions = {}, catalogName } = product;
      let { displayformattedValue: basePriceFormattedValue = '' } = basePrice;
      let { displayformattedValue: wasPriceFormattedValue = '' } = wasPriceData;
      images.map((img, i) => {
        if (img.format === 'cartIcon') {
          image = img.url;
          altText = img.altText
        }
      });
      let colorVariantOptions;
      let sizeVariantOptions;
      baseOptions.map((variant, i) => {
        if (variant.variantType === 'FnlColorVariant') {
          colorVariantOptions = variant;
        } else if (variant.variantType === 'FnlSizeVariant') {
          sizeVariantOptions = variant;
        }
      });
      let colorCode = '';
      let colorName = '';
      let sizeName = '';
      let sizeCode = '';
      if (colorVariantOptions && colorVariantOptions.selected !== undefined) {
        colorVariantOptions.selected.variantOptionQualifiers.forEach((colorSwatch, j) => {
          if (colorSwatch.name === 'Color') {
            colorName = colorSwatch.value;
            colorCode = colorVariantOptions.selected.code;
          }
        });
      }
      if (product.verticalColor) {
        colorName = product.verticalColor;
      }
      let variantData;
      if (sizeVariantOptions && sizeVariantOptions.selected !== undefined) {
        variantData = sizeVariantOptions.selected.variantOptionQualifiers;
        sizeVariantOptions.selected.variantOptionQualifiers.forEach((sizeSwatch, j) => {
          if (sizeSwatch.name === 'Size*') {
            sizeName = sizeSwatch.value;
            sizeCode = sizeVariantOptions.selected.code;
          }
        });
      }
      const { sizeUI = '' } = fetchSizeAndBrandSize(variantData, newSizeRevampFlag);

      let sp = basePrice.value || 0;
      let cp = wasPriceData.value || 0;
      let discount;
      let discountPercent;
      if (sp && cp && sp !== cp) {
        discount = Math.round(((cp - sp) / cp) * 100);
        discountPercent = `${discount}% off`;
      }
      let fnlColorVariantData = product || {};
      let { exclusiveTill = '' } = fnlColorVariantData;
      const { selected: { variantOptionQualifiers = [] } = {} } = sizeVariantOptions;
      const { valueWithUnit: volume = '', hideSizes } = beautyCheck(variantOptionQualifiers) || {};
      const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, catalogName);

      return (
        <div className="mini-prod-details" key={index} tabIndex={0}>
          <div className="minicart-details-block">
            <div className="minicart-img-blk" tabIndex={0}>
              <a href={product.url} tabIndex={0}>
                <img className="minicart-img" src={`${replaceWithJioCDN(image)}`} alt={altText}/>
              </a>
              {exclusiveTill ? <div className="cart-exclusive" aria-label="EXCLUSIVE" tabIndex={0}>EXCLUSIVE</div> : ''}
            </div>

            <div className="minicart-details" tabIndex={0}>
              <div className="minicart-price" tabIndex={0}><strong>{basePriceFormattedValue}</strong></div>
              {discountPercent && hideMRP && (
                <div className="minicart-offer-price" tabIndex={0}>
                  <span className="strike-off-price" tabIndex={0}>{wasPriceFormattedValue}</span>&nbsp;{' '}
                  <span className="discount-price" tabIndex={0}>
                    <strong>{newDesignLuxe ? discountPercent : discountPercent}</strong>
                  </span>
                </div>
              )}

              <div className="minicart-prod-name" tabIndex={0}>
                <a href={product.url} aria-label={`${product.brandName} - ${product.name}`}>
                  {product.brandName} - {product.name}
                </a>
              </div>

              <div className="minicart-spec" tabIndex={0}>
                {colorName && (
                  <div className="minicart-blk" tabIndex={0}>
                    <div className="minicart-heading" aria-label="Colour" tabIndex={0}>Colour</div>
                    <div className="minicart-value" tabIndex={0}><strong>{colorName}</strong></div>
                  </div>
                )}

                {(sizeName || sizeUI) && !volume && !hideSizes && (
                  <div className="minicart-blk" tabIndex={0}>
                    <div className="minicart-heading" tabIndex={0} aria-label="Size">Size</div>
                    <div className="minicart-value" tabIndex={0}><strong>{sizeUI || sizeName}</strong></div>
                  </div>
                )}

                <div className="minicart-blk" tabIndex={0}>
                  <div className="minicart-heading" tabIndex={0} aria-label="Qty">Qty</div>
                  <div className="minicart-value" tabIndex={0}><strong>{quantity}</strong></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    return <div>{dataListItems}</div>;
  }
}

const mapStateToProps = state => {
  const { metaData = {}, flags = {} } = state;
  return {
    minicart: state.minicart.Minicart,
    metaData,
    newSizeRevampFlag: getNewSizeRevampFlag(flags),
    storesForHidingMRP: getStoresForHidingMRP(state)
  };
};
const mapDispatchToProps = dispatch => {
  return {
    removeCartProduct: (entry, productId, qty) =>
      dispatch(actions.removeCartProduct(entry, productId, qty))
  };
};
export default CartPopup = connect(mapStateToProps, mapDispatchToProps)(CartPopup);
